import { Directive } from '@angular/core';

/**
 * We need to have wrapper for loading advanced filters
 * for that we need to have a directive a reference
 * for much cleaner approach
 * */
@Directive({
  selector: 'wcg-advanced-filter-wrapper-directive',
})
export class AdvancedFilterWrapperDirective {}
